export const SET_ALL_DELEGATIONS = 'SET_ALL_DELEGATIONS'
export const ADD_NEW_DELEGATION = 'ADD_NEW_DELEGATION'
export const DELETE_DELEGATION = 'DELETE_DELEGATION'
export const UPDATE_EXISTING_DELEGATION = 'UPDATE_EXISTING_DELEGATION'
